import React from "react";
import { Modal, CloseButton } from "react-bootstrap";
import Loader from '../../Assets/Images/loader.gif';

function ModalBox(props) {

    return (
    <Modal
      show={props.isShow}
      // onHide={props.handleClose}
      dialogClassName={`modal-dialog modal-${props.modalSize ? props.modalSize : 'lg' }`}
    >
      {/* <Modal.Header className="border-0 pt-4"> */}
      <div class="modal-header d-flex justify-content-end border-0 pb-0">
      {props.handleClose &&  <CloseButton
          onClick={props.handleClose}
          className={props.className}
        >
         <span class="material-symbols-outlined"> close</span>
          </CloseButton>}
          </div>
      {/* </Modal.Header> */}
      <Modal.Body>
        {!props.hasData ? (
          <Loader />
        ) : (
          props.children
        )}
      </Modal.Body>
    </Modal>
  );
}

export default ModalBox;
